import { PANEL } from "./panelTokens";

/** Panel topbar — ortak light-theme sx */
export const panelTopbarShellSx = {
  width: "100%",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  background: PANEL.surface,
  borderBottom: `1px solid ${PANEL.border}`,
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
};

export const panelTopbarInnerSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: { xs: 2, md: 3, lg: 4 },
  py: { xs: 1.2, md: 1.5 },
  gap: 2,
};

export const panelTopbarMenuButtonSx = {
  display: { xs: "inline-flex", md: "none" },
  color: PANEL.text.muted,
  borderRadius: 1.5,
  "&:hover": {
    backgroundColor: PANEL.pageBg,
    color: PANEL.text.primary,
  },
  transition: "all 0.15s ease",
};

export const panelTopbarTitleSx = {
  color: PANEL.text.primary,
  fontWeight: 700,
  letterSpacing: -0.2,
  lineHeight: 1.2,
};

export const panelTopbarSubtitleSx = {
  color: PANEL.text.muted,
};

export const panelTopbarIconButtonSx = {
  color: PANEL.text.muted,
  "&:hover": {
    color: PANEL.text.primary,
    backgroundColor: PANEL.pageBg,
  },
};

export const panelTopbarPrimaryButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.8125rem",
  borderRadius: 2,
  px: 2.5,
  py: 0.8,
  background: PANEL.accent.main,
  color: PANEL.accent.contrast,
  boxShadow: "none",
  "&:hover": {
    background: PANEL.accent.hover,
    boxShadow: PANEL.accent.shadow25,
  },
  transition: "all 0.15s ease",
};

export const panelTopbarLogoutButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.8125rem",
  borderRadius: 2,
  px: { xs: 1.5, sm: 2.5 },
  py: 0.8,
  borderColor: PANEL.danger.main,
  color: PANEL.danger.text,
  "&:hover": {
    borderColor: PANEL.danger.text,
    backgroundColor: PANEL.danger.soft,
  },
  transition: "all 0.15s ease",
};

export const panelTopbarBrandAvatarSx = {
  display: { xs: "none", md: "flex" },
  width: 38,
  height: 38,
  background: PANEL.accent.soft18,
  color: PANEL.accent.text,
  borderRadius: 2,
  border: `1px solid ${PANEL.accent.softBorder}`,
};

export const panelTopbarProfileChipSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  px: 2,
  py: 1,
  borderRadius: "12px",
  backgroundColor: PANEL.accent.soft12,
  border: `1px solid ${PANEL.accent.softBorder}`,
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: PANEL.accent.soft18,
    transform: "translateY(-1px)",
    boxShadow: PANEL.shadow.card,
  },
};

export const panelTopbarAvatarSx = {
  width: 36,
  height: 36,
  background: PANEL.accent.soft12,
  color: PANEL.accent.text,
  border: `2px solid ${PANEL.accent.softBorder}`,
  fontSize: "0.9rem",
  fontWeight: 700,
};
